import React from "react";

//COMPONENTS
import { HeaderLaptop, HeaderMobile } from "../components/Header";
import Cta from "../components/Cta";
import ServiceContent from "../components/ServiceContent";
//ASSETS
import InvestmentAcquisitionImage from "../assets/investment-acquisition-header.svg";
import IAImg1 from "../assets/investment-acquisition-1.svg";
import IAImg2 from "../assets/investment-acquisition-2.svg";
import IAImg3 from "../assets/investment-acquisition-3.svg";

const content = [
  {
    text: (
      <p>
        Mergers and acquisitions enable businesses to accelerate their development by 
        creating value in various ways, allowing a faster and often less costly path to 
        expansion compared with an ‘organic’ growth route.
      </p>
    ),
    img: IAImg1,
  },
  {
    text: (
      <p>
        Developing new products and services, increasing sales, and expanding into new 
        markets in an organic way is certainly a measure of success, but this strategy 
        typically takes time, and when companies need a speedier approach, M&A transaction 
        can be very beneficial.
      </p>
    ),
    img: IAImg2,
  },
  {
    text: (
      <p>
        Nectar Consulting are always on the look out for investment & acquisition opportunities 
        within any sector, whether you are a start up or growing business. We can offer private 
        funding through our partners and with our expert team, help your business to grow from within.
      </p>
    ),
    img: IAImg3,
  },
];

const InvestmentAcquisition = () => {
  return (
    <div>
      <HeaderLaptop
        titlePart1="Investment &"
        titlePart2=" Acquisition"
        pageSnippet="Dedicated to the creation, support and development of new businesses and existing businesses through our acquisition and investment opportunities."
        headerIllustration={InvestmentAcquisitionImage}
        alt="Business advisory conversation"
      />
      <HeaderMobile
        titlePart1="Investment &"
        titlePart2=" Acquisition"
        pageSnippet="Dedicated to the creation, support and development of new businesses and existing businesses through our acquisition and investment opportunities."
        headerIllustration={InvestmentAcquisitionImage}
        alt="Business advisory conversation"
      />

      <div className="max-w-7xl mx-auto px-4 my-16 sm:px-6 lg:my-32">
        <h2 className="header2 text-center">
          Helping your Business to
          <span className="text-earth"> Grow & Flourish</span>
        </h2>
        {content.map((item, index) => (
          <ServiceContent
            key={index}
            isLast={index === content.length - 1}
            img={item.img}
            alt={item.alt}
            text={item.text}
            isLeftAlign={index % 2}
          />
        ))}
      </div>

      <Cta />
    </div>
  );
};

export default InvestmentAcquisition;
